export const getStatus = (value: number) => {
     const arr = ['', 'In Queue', 'In-Progress', 'Success', 'Failed', 'Cancelled', 'Partially Success', 'Fetching Configuration', 'In-Progress', 'Failed', 'Cancelled', 'Renaming...'];
    return arr[value];
}

export const NOTIFICATION_REASONS = [
    'risk_accepted',
    'assets_decommissioned',
    'new_asset_added',
    'asset_imported',
    'asset_updated',
    // 'assets_recommissioned',
    'assets_location_updated',
    'assets_deleted',
    'region_added',
    'region_deleted',
    'region_updated',
    'role_deleted',
    'role_updated',
    'user_activated',
    'user_deactivated',
    'user_invited',
    'user_role_updated',
    'scan_uploaded',
    'asset_rescanned',
    'asset_criticality',
    'discovery_updates',
    'cloud_schedule',
    'cloud_scan',
    'report_added',
    'report_delete',
    'report_update',
    'report_download',
    'vpn_added',
    'vpn_paused',
    'vpn_deleted',
    'vpn_edited',
    'vpn_resumed',
    'credential_added',
    'credential_edited',
    'credential_deleted',
    'subscription_added',
    'subscription_edited',
    'jira_issue_created',
    'jira_issue_updated',
    'cve_updates',
    'cloud_scan_initiated',
    'cloud_scan_completed',
    'cloud_schedule_initiated',
    'cloud_schedule_completed',
    'schedule_scan_created'
];

/**
 * Customized notification messages for each action type.
 * These messages are displayed in the confirmation toast when socket events are received.
 */
export const NOTIFICATION_MESSAGES: Record<string, string> = {
    // Asset Management
    'risk_accepted': 'Risk acceptance status has been updated. Refresh to view the latest changes.',
    'assets_decommissioned': 'One or more assets have been decommissioned. Refresh to view the updated asset list.',
    'new_asset_added': 'A new asset has been added to the inventory. Refresh to view it.',
    'asset_imported': 'Assets have been imported successfully. Refresh to view the updated inventory.',
    'asset_updated': 'Asset details have been updated. Refresh to view the latest information.',
    // 'assets_recommissioned': 'One or more assets have been recommissioned. Refresh to view the updated status.',
    'assets_location_updated': 'Asset location information has been updated. Refresh to view the changes.',
    'assets_deleted': 'One or more assets have been deleted. Refresh to view the updated asset list.',
    'asset_rescanned': 'Asset rescan has been completed. Refresh to view the latest scan results.',
    'asset_criticality': 'Asset criticality level has been updated. Refresh to view the changes.',

    // Region Management
    'region_added': 'A new region has been added. Refresh to view the updated region list.',
    'region_deleted': 'A region has been deleted. Refresh to view the updated region list.',
    'region_updated': 'Region details have been updated. Refresh to view the changes.',

    // User & Role Management
    'role_deleted': 'A role has been deleted. Refresh to view the updated roles.',
    'role_updated': 'Role permissions have been updated. Refresh to view the changes.',
    'user_activated': 'A user account has been activated. Refresh to view the updated user list.',
    'user_deactivated': 'A user account has been deactivated. Refresh to view the updated user list.',
    'user_invited': 'A new user has been invited. Refresh to view the updated user list.',
    'user_role_updated': 'User role assignment has been updated. Refresh to view the changes.',

    // Scan Management
    'scan_uploaded': 'Scan results have been uploaded successfully. Refresh to view the data.',
    'discovery_updates': 'Discovery scan has been updated. Refresh to view the latest findings.',
    'cloud_schedule': 'Cloud scan schedule has been updated. Refresh to view the changes.',
    'cloud_scan': 'Cloud scan has been completed. Refresh to view the results.',
    'cloud_scan_initiated': 'Cloud scan has been initiated. Refresh to view the status.',
    'cloud_scan_completed': 'Cloud scan has been completed. Refresh to view the results.',
    'cloud_schedule_initiated': 'Cloud scan schedule has been initiated. Refresh to view the status.',
    'cloud_schedule_completed': 'Cloud scan schedule has been completed. Refresh to view the updated schedule.',

    // Report Management
    'report_added': 'A new report has been generated. Refresh to view it.',
    'report_delete': 'A report has been deleted. Refresh to view the updated report list.',
    'report_update': 'Report details have been updated. Refresh to view the changes.',
    'report_download': 'Report download has been initiated. Refresh to check the status.',

    // VPN Management
    'vpn_added': 'A new VPN configuration has been added. Refresh to view it.',
    'vpn_paused': 'VPN connection has been paused. Refresh to view the updated status.',
    'vpn_deleted': 'VPN configuration has been deleted. Refresh to view the updated list.',
    'vpn_edited': 'VPN configuration has been updated. Refresh to view the changes.',
    'vpn_resumed': 'VPN connection has been resumed. Refresh to view the updated status.',

    // Credential Management
    'credential_added': 'New credentials have been added. Refresh to view the updated list.',
    'credential_edited': 'Credential details have been updated. Refresh to view the changes.',
    'credential_deleted': 'Credentials have been deleted. Refresh to view the updated list.',

    // Subscription Management
    'subscription_added': 'A new subscription has been added. Refresh to view the details.',
    'subscription_edited': 'Subscription details have been updated. Refresh to view the changes.',

    // Jira Integration
    'jira_issue_created': 'A new Jira issue has been created. Refresh to view the details.',
    'jira_issue_updated': 'Jira issue has been updated. Refresh to view the latest status.',

    // CVE Updates
    'cve_updates': 'CVE information has been updated. Refresh to view the latest vulnerabilities.',

    // Schedule Scan
    'schedule_scan_created': 'A new scan schedule has been created. Refresh to view the changes.',
};

/**
 * Returns the appropriate notification message for a given action.
 * Falls back to a default message if the action is not found.
 * @param action - The notification action type
 * @returns The corresponding notification message
 */
export const getNotificationMessage = (action: string): string => {
    return NOTIFICATION_MESSAGES[action] || 'Data has been updated. Refresh to view the latest changes.';
};